/**
 * 修改密码
 */
import React, { useState } from 'react';
import { FormattedMessage } from 'umi';
import { useFomatter } from '@/hooks';
// 组件
import { Modal, Form, Input, notification, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import md5 from 'js-md5';
// 正则
import { TEST_PASSWORD_Bedge, TEST_PASSWORD_STRONG, TEST_INCLUDE_CHINESE } from '@/utils/regular';
// api
import {
  checkUserPassword_api,
  postUpdatePassword_api,
  postMemberUpdateOauth2pwd_api,
} from '@/api/user';
// 枚举
// style
import '../style.less';
type propsType = {
  /** 是否显示弹窗 */
  visible?: boolean;
  oauthVisible?: boolean; //第三方授权修改密码弹窗状态
  data: any;
  /** 操作visible */
  handleVisible?: any;
  /** 提交后回调 */
  successCallback?: any;
  oauthCallback?: any; //第三方授权修改密码回调
};
const ChangePassword: React.FC<propsType> = ({
  visible = false,
  handleVisible,
  data,
  oauthVisible = false,
  oauthCallback,
}) => {
  const { formatter } = useFomatter();
  const [loading, setLoading] = useState<boolean>(false);
  const [changeVisible, setChangeVisible] = useState<boolean>(false);
  const [passwordStatus, setPasswordStatus] = useState<any>('success'); //密码校验状态
  const [errorMsg, setErrorMsg] = useState<string | React.ReactNode>(''); //密码校验状态

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  // 自定义校验密码
  const changePassword = (value: string) => {
    if (value) {
      if (value.length < 8 || value.length > 20) {
        setPasswordStatus('error');
        setErrorMsg(<FormattedMessage id="register.changePassword.message.rule" />);
        return 'error';
      } else if (TEST_INCLUDE_CHINESE.test(value) || !TEST_PASSWORD_Bedge.test(value)) {
        setPasswordStatus('error');
        setErrorMsg(
          <div>
            <Tooltip
              title={
                <div style={{ color: '#000' }}>
                  <FormattedMessage id="register.changePassword.rule.title2" />
                  <div>
                    1{')'} <FormattedMessage id="register.changePassword.rule.text21" />
                  </div>
                  <div>
                    2{')'} <FormattedMessage id="register.changePassword.rule.text22" />
                  </div>
                  <div>
                    3{')'} <FormattedMessage id="register.changePassword.rule.text23" />
                  </div>
                </div>
              }
              color="#fff"
            >
              <InfoCircleOutlined />
            </Tooltip>
            <span style={{ marginLeft: 5 }}>
              <FormattedMessage id="register.changePassword.message.error" />
            </span>
          </div>,
        );
        return 'error';
      } else if (!TEST_PASSWORD_STRONG.test(value)) {
        setPasswordStatus('warning');
        setErrorMsg(
          <div>
            <Tooltip
              title={
                <div style={{ color: '#000' }}>
                  <FormattedMessage id="register.changePassword.rule.title" />
                  <div>
                    1{')'} <FormattedMessage id="register.changePassword.rule.text1" />
                  </div>
                  <div>
                    2{')'} <FormattedMessage id="register.changePassword.rule.text2" />
                  </div>
                  <div>
                    3{')'} <FormattedMessage id="register.changePassword.rule.text3" />
                  </div>
                  <div>
                    4{')'} <FormattedMessage id="register.changePassword.rule.text4" />
                  </div>
                </div>
              }
              color="#fff"
            >
              <InfoCircleOutlined />
            </Tooltip>
            <span style={{ marginLeft: 5 }}>
              <FormattedMessage id="register.changePassword.rule.weak" />
            </span>
          </div>,
        );
        return 'warning';
      } else {
        setPasswordStatus('success');
        setErrorMsg(
          <div style={{ color: '#52C41A' }}>
            <FormattedMessage id="register.changePassword.message.strong" />
          </div>,
        );
        return 'success';
      }
    } else {
      setPasswordStatus('error');
      setErrorMsg(<FormattedMessage id="register.changePassword.message" />);
      return 'error';
    }
  };

  // 密码验证表单提交
  const handleSubmit = () => {
    form1
      .validateFields()
      .then(() => {
        setChangeVisible(true);
      })
      .catch((errorInfo) => {
        console.log(errorInfo, '.catch(errorInfo =');
      });
  };

  // 修改密码表单提交
  const handleChangeEmail = () => {
    const password = form2.getFieldValue('password');
    const oldPassword = oauthVisible ? '' : form1.getFieldValue('password');

    const status = changePassword(password);
    if (status === 'error') {
      return;
    }
    form2.validateFields().then(async () => {
      let params: any = { password: md5(password) };
      let API = postUpdatePassword_api;
      if (oauthVisible) {
        //第三方授权修改密码
        API = postMemberUpdateOauth2pwd_api;
      } else {
        params = {
          ...params,
          oldPassword: md5(oldPassword),
        };
      }
      setLoading(true);
      const res: any = await API(params);
      setLoading(false);
      if (res.success) {
        setChangeVisible(false);
        handleVisible?.(false);
        oauthCallback?.(true);
        notification.success({
          message: formatter({ id: 'register.modified.message' }),
        });
      }
    });
    // .catch(() => {});
  };

  // 校验密码是否正确
  const validatorPassword = (_: any, value: string, callback: any) => {
    if (value) {
      const params = {
        id: data.id,
        password: md5(value),
      };
      checkUserPassword_api(params).then((res: any) => {
        if (res.success && res.data) {
          callback();
        } else {
          callback(formatter({ id: 'accountSettings.general.validatorPassword.message' }));
        }
      });
    } else {
      callback();
    }
  };

  // 校验再次输入密码
  const validatorRePassword = (_: any, value: string, callback: any) => {
    if (value) {
      const password = form2.getFieldValue('password');
      if (value !== password) {
        callback(formatter({ id: 'accountSettings.general.validatorRePassword.message' }));
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  // 表单校验失败回调(唤起对密码的校验)
  const handleFailed = () => {
    const password = form2.getFieldValue('password');
    changePassword(password);
  };

  return (
    <>
      <Modal
        wrapClassName="m-changePasswordModal"
        title={<FormattedMessage id="accountSettings.general.ChangePassword" />}
        visible={visible}
        width={500}
        destroyOnClose={true}
        centered={true}
        maskClosable={false}
        onCancel={() => {
          handleVisible?.(false);
        }}
        onOk={handleSubmit}
        okText={<FormattedMessage id="accountSettings.general.ChangePassword" />}
      >
        <Form layout="vertical" form={form1}>
          <p>
            <FormattedMessage id="accountSettings.general.Modal.p0" />
          </p>
          <Form.Item label={<FormattedMessage id="accountSettings.general.Form.password.title" />}>
            <Form.Item
              name="password"
              noStyle
              rules={[
                {
                  required: true,
                  message: formatter({ id: 'accountSettings.general.Form.password.message' }),
                },
                {
                  validator: validatorPassword,
                },
              ]}
              validateTrigger="onBlur"
            >
              <Input.Password placeholder="·····" size="large" />
            </Form.Item>
          </Form.Item>
        </Form>
      </Modal>
      {/* 二次输入 */}
      {changeVisible || oauthVisible ? (
        <Modal
          title={<FormattedMessage id="accountSettings.general.ChangePassword" />}
          visible={changeVisible || oauthVisible}
          width={500}
          destroyOnClose={true}
          centered={true}
          maskClosable={false}
          onCancel={() => {
            form2.resetFields();
            setChangeVisible(false);
            if (oauthVisible) {
              oauthCallback?.(false);
            }
          }}
          onOk={handleChangeEmail}
          okText={<FormattedMessage id="accountSettings.general.ChangePassword" />}
          confirmLoading={loading}
        >
          <Form layout="vertical" form={form2} onFinishFailed={handleFailed}>
            {data.authType !== 'EMAIL' ? (
              <div style={{ marginBottom: 20, color: '#666' }}>
                <FormattedMessage id="accountSettings.general.oauthPw.message" />
              </div>
            ) : null}
            <Form.Item
              label={<FormattedMessage id="accountSettings.general.Form.password.title" />}
              validateStatus={passwordStatus}
              help={errorMsg}
            >
              <Form.Item name="password" noStyle>
                <Input.Password
                  placeholder="·····"
                  size="large"
                  onBlur={(e: any) => {
                    changePassword(e.target.value);
                  }}
                />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={<FormattedMessage id="accountSettings.general.Form.rePassword.title" />}
            >
              <Form.Item
                name="rePassword"
                noStyle
                rules={[
                  {
                    required: true,
                    message: formatter({ id: 'accountSettings.general.Form.password.message' }),
                  },
                  {
                    validator: validatorRePassword,
                  },
                ]}
              >
                <Input.Password placeholder="·····" size="large" />
              </Form.Item>
            </Form.Item>
          </Form>
        </Modal>
      ) : null}
    </>
  );
};
export default ChangePassword;
